<template>
  <v-dialog
    v-model="dialogOpen"
    class="dialog"
    content-class="yt-player__dialog"
    width="auto"
    @click:outside="dialogClose"
  >
    <div
      class="yt-player"
      :class="{ 'auto-adjust-height': autoAdjustHeight }"
    >
      <div
        class="yt-player__overlay"
        @click="dialogClose"
      >
        <div
          class="yt-player__container"
          @click.stop
        >
          <div
            class="yt-player__close"
            :class="{ shorts: isShorts }"
            @click="dialogClose"
          >
            <i class="icon icon-close" />
          </div>
          <iframe
            v-if="videoId"
            :class="{ shorts: isShorts }"
            :src="videoUrl"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
    // YouTube 影片 ID
    videoId: {
      type: String,
      required: true
    },
    isShorts: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogOpen: false,
      isMobile: false,
      autoAdjustHeight: false,
      debouncedResizeHandler: null
    }
  },
  computed: {
    /**
     * 產生 YouTube 影片網址
     * @returns {string} YouTube embedded URL
     */
    videoUrl () {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&playsinline=1&mute=1`
    }
  },
  watch: {
    async open (val) {
      this.dialogOpen = val
      if (val) {
        await this.$nextTick()
        this.resizeHandler()
      }
    }
  },
  mounted () {
    this.dialogOpen = this.open
    this.isMobile = screen.width <= 768

    this.debouncedResizeHandler = _.debounce(this.resizeHandler, 600)
    window.addEventListener('resize', this.debouncedResizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.debouncedResizeHandler)
  },
  methods: {
    /**
     * 關閉影片播放器
     */
    dialogClose () {
      this.$emit('close')
    },
    resizeHandler () {
      const { width, height } = {
        width: window.innerWidth,
        height: window.innerHeight
      }
      // 如果比例大於 16:9 或 9:16，則切換成高度優先
      this.autoAdjustHeight = this.isShorts ? width / height > 9 / 16 : width / height > 16 / 9
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .yt-player__dialog {
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  max-height: none;
}
.yt-player {
  display: flex;
  max-width: 100%;
  max-height: 100%;
  &__overlay {
    display: flex;
    justify-content: center;
    overflow: hidden;
    background: #000;
  }

  &__container {
    max-width: 980px;
    position: relative;
    width: 100%;
    display: flex;
    iframe {
      aspect-ratio: 16 / 9;
      height: auto;
      width: 980px;
      max-height: 550px;
      z-index: 2;
      position: relative;
      background: #000;

      &.shorts {
        aspect-ratio: 9 / 16;
        width: 360px;
        max-height: none;
      }
    }
  }

  &__close {
    background-color: transparent;
    cursor: pointer;
    position: fixed;
    right: calc((100% - 980px) / 2 - 40px);
    top: 5%;
    z-index: 1;

    i {
      color: #ffffff;
      font-size: 24px;
    }

    @media (max-width: 1120px) {
      right: 32px;
    }

  }

  &.auto-adjust-height {
    .yt-player__container {
      iframe {
        width: auto;
        height: calc(100vh - 48px);
      }
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  ::v-deep .yt-player__dialog {
    margin: 16px;
  }
  .yt-player {
    &__close {
      &.shorts {
        top: 16px;
        right: 8px;
      }
      i {
        font-size: 15px;
      }
    }
    &.auto-adjust-height {
      .yt-player__container {
        iframe {
          height: calc(100vh - 32px);
        }
      }
    }
  }
}
</style>
